import React, { useMemo } from "react"
import { Console } from "@nicksrandall/console-feed"
import { useRecoilState } from "recoil"
import LuxonUtils from "@date-io/luxon"
import { useTranslation } from "react-i18next"
import { ConsoleClear, ConsoleLoggerContainer } from "./ConsoleUi.style"
import { websocketState } from "./ConsoleUi.state"

const ConsoleLogger = ({ className = '' }) => {
    const { t } = useTranslation();
    const [wsMessage, setWsMessage] = useRecoilState(websocketState);
    const logs = useMemo(() => {
        const luxon = new LuxonUtils()
        return wsMessage.map(message => ({
            method: 'websocket',
            timestamp: luxon.date(message.time).toFormat('yyyy-MM-dd HH:mm:ss'),
            data: [message],
        }))
    }, [wsMessage])
    return (
        <ConsoleLoggerContainer className={className}>
            {
                logs.length > 0
                    ? (
                        <ConsoleClear
                            className="btn--flat"
                            color="light"
                            outline
                            size="sm"
                            onClick={() => setWsMessage([])}
                        >
                            <span>{t(`Clear console`)}</span>
                        </ConsoleClear>
                    )
                    : null
            }
            <Console logs={logs} variant="dark" />
        </ConsoleLoggerContainer>
    )
}

export default ConsoleLogger